//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getAllCatalogue, addPageView1 } from '@/api/youzheng'
import config from '@/config'
import { TreeSelect, Cell } from 'vant'
export default {
  name: 'booklist',
  components: {
    [TreeSelect.name]: TreeSelect,
    [Cell.name]: Cell
  },
  props: {},
  data () {
    return {
      booklist: '',
      baseUrl: config.baseUrl,
      id: this.$route.params.code,
      title: this.$route.params.name,
      page: 1,
      rows: 20,
      active: 0,
      mulu: []
    }
  },
  created () {
    this.addlog()
  },
  mounted () {
    document.title = this.title
    this.getinfor()
  },
  methods: {
    addlog () {
      addPageView1({
        id: this.id
      })
    },
    getinfor () {
      getAllCatalogue({
        bookid: this.id,
        page: this.page,
        rows: this.rows
      }).then(res => {
        this.booklist = res.obj
        // this.booklist = res.rows[0].ebooks
        // console.log(this.booklist)
      })
    },
    linkdetail (id) {
      this.$router.push({ name: 'bookdetail', params: { code: id } })
    }
  }
}
